import {
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  Observable,
  of,
  Subject,
  takeUntil,
} from 'rxjs';
import { AuthService } from '../../core/service/auth.service';
import { UserService } from '../../core/service/user.service';
import { AuditService } from "../../core/service/audit.service";
import {
  PastTermVisibilityService
} from "../../feature/past-term-registration-form/services/past-term-visibility-service/past-term-visibility.service";

@Component({
    selector: 'app-user-dropdown',
    templateUrl: './user-dropdown.component.html',
    styleUrls: ['./user-dropdown.component.scss'],
    standalone: false
})
export class UserDropdownComponent implements OnInit, OnDestroy {
  public userName$!: Observable<string | undefined>;
  public isAdmin$!: Observable<boolean> | undefined;
  public canImpersonate$!: Observable<boolean> | undefined;
  public isSupervisor$!: Observable<boolean> | undefined;
  public needsCSER100$: Observable<boolean> = of(false);
  public modalOpen: boolean = false;

  public endSubscription$ = new Subject();
  public shouldShowPastTermRegistrationLink!: boolean;

  @Input()
  public creditProgressText: string = '';

  constructor(private auditService: AuditService,
              private authService: AuthService,
              private userService: UserService,
              private pastTermVisibilityService: PastTermVisibilityService) {}

  ngOnInit() {
    this.userName$ = this.authService.getCurrentUserDisplayName().pipe(takeUntil(this.endSubscription$));
    this.isAdmin$ = this.authService.isAdmin().pipe(takeUntil(this.endSubscription$));
    this.isSupervisor$ = this.authService.isSupervisor().pipe(takeUntil(this.endSubscription$));
    this.canImpersonate$ = this.authService.canImpersonate().pipe(takeUntil(this.endSubscription$));
    this.needsCSER100$ = this.auditService.needsCSER100().pipe(takeUntil(this.endSubscription$));

    this.pastTermVisibilityService
      .updatePastTermLinkVisibility
      .subscribe((shouldShow: boolean): boolean =>
        this.shouldShowPastTermRegistrationLink = shouldShow);
  }

  ngOnDestroy(): void {
    this.endSubscription$.next(true);
    this.endSubscription$.unsubscribe();
  }

  public logOut(): void {
    this.userService.signOut();
  }

  public openModal() {
    this.modalOpen = true;
  }

  public onModalClose() {
    this.modalOpen = false;
  }

}
